document.addEventListener('alpine:init', () => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = []
  }

  Alpine.data('Wishlist', () => ({
    wishlistProducts: [],

    init() {
      this.initSwymWishlistProducts()
    },

    initSwymWishlistProducts() {
      const self = this

      window.SwymCallbacks.push(() => {
        _swat.fetchWrtEventTypeET((products) => {
          self.mapProductData(products)
        }, _swat.EventTypes.addToWishlist)
      })
    },

    async mapProductData(swymProducts = []) {
      const products = await Promise.all(
        swymProducts.map((item) =>
          this.fetchProductData(item).then((res) => {
            return {
              ...res,
              swymData: item,
            }
          })
        )
      )

      this.wishlistProducts = products.filter((item) => 'id' in item)
    },

    async fetchProductData(swymProduct) {
      try {
        const productURL = `${swymProduct?.du}.js`

        const res = await fetch(productURL)

        if (!res.ok) throw new Error(res.status)

        return res.json()
      } catch (error) {
        console.error('Product not found', error)
      }
    },

    removeWishlistProduct(product, event) {
      let onSuccess = function (deletedProduct) {
        console.log('Successfully deleted the Product', deletedProduct)
        event.closest('.main-wishlist__item').classList.add('fadeOut')
        setTimeout(() => {
          event.closest('.main-wishlist__item').remove()
        }, 1000)
      }

      let onError = function (error) {
        console.error('Error while deleting the Product', error)
      }

      let fetchLid = function (lists) {
        let productWishlistLid = lists[0].lid
        let productData = {
          epi: product.swymData.epi,
          empi: product.swymData.empi,
          du: product.swymData.du,
        }

        if (productWishlistLid) {
          _swat.deleteFromList(
            productWishlistLid,
            productData,
            onSuccess,
            onError
          )
        }
      }

      _swat.fetchLists({
        callbackFn: fetchLid,
        errorFn: onError,
      })
    },
  }))

  Alpine.data('WishlistItem', (product) => ({
    product: product,

    swymData: product.swymData,

    activeVariant: product.variants[0],

    init() {
      this.activeVariant =
        product.variants.find((variant) => {
          return variant.id === this.swymData.epi
        }) || product.variants[0]
    },

    get activeVariantSizes() {
      return (
        this.product.variants.filter((variants) => {
          // Return same color
          return this.activeVariant.option2 === variants.option2
        }) || this.product.variants
      )
    },

    get price() {
      return formatPrice(this.activeVariant.price, 0)
    },

    get comparedPrice() {
      const comparedPrice =
        this.activeVariant?.compare_at_price ||
        this.activeVariant?.compare_at_price_max

      if (!comparedPrice || comparedPrice <= this.activeVariant.price)
        return false

      return formatPrice(comparedPrice, 0)
    },

    get productMedia() {
      const media = this.product?.media[0]
      if (!media) return null
      return {
        ...media,
        sizedUrl:
          media.media_type === 'image'
            ? getImageWithSize(media.src, 1440)
            : media.src,
      }
    },

    get secondProductMedia() {
      const media = this.product?.media[1]
      if (!media) return null
      return {
        ...media,
        sizedUrl:
          media.media_type === 'image'
            ? getImageWithSize(media.src, 1440)
            : media.src,
      }
    },

    getSizeVariantLabel(variant) {
      const labels = {
        'x-small': 'XS',
        small: 'S',
        medium: 'M',
        large: 'L',
        'x-large': 'XL',
      }

      return labels[variant.option1.toLowerCase()] || variant.option1
    },

    handleSizeChange(variant) {
      this.activeVariant = variant
    },

    handleMediaHoverEnter(event) {
      if (this.secondProductMedia?.media_type === 'video') {
        const videoElement = event.currentTarget.querySelector(
          '.media--secondary video'
        )
        if (videoElement) {
          videoElement.play()
        }
      }
    },

    handleMediaHoverLeave(event) {
      if (this.secondProductMedia?.media_type === 'video') {
        const videoElement = event.currentTarget.querySelector(
          '.media--secondary video'
        )
        if (videoElement) {
          videoElement.pause()
        }
      }
    },
  }))
})
